import { Button } from '@mui/material';
import { useState } from 'react';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CustomDropdown from '../custom-dropdown/CustomDropdown';
import CustomButton from '../button/CustomButton';

export interface IActionMenuItem {
  key: string;
  text: React.ReactNode;
  onClick: () => void;
}

export interface IActionMenuProps {
  // Define any props you want to pass to the ActionMenu component
  text: string;
  menu: IActionMenuItem[];
}

const ActionMenu = ({ text, menu }: IActionMenuProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <CustomDropdown
      menuItemsContents={menu}
      renderDropdownButtonElement={({ onClick }) => (
        <CustomButton
          onClick={(e: React.MouseEvent<HTMLDivElement>) => {
            onClick(e);
            setIsOpen(!isOpen);
          }}
          variant="primary"
          // startIcon={<PaymentIcon fill={primaryLight[500]} />}
          endIcon={isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        >
          {text}
        </CustomButton>
      )}
      onClickAway={() => setIsOpen(false)}
      dropdownSx={{
        width: '300px',
        marginTop: '0',
        py: '0.5rem',
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
      }}
    />
  );
};

export default ActionMenu;
